import { useEffect, useRef } from 'react';
import { recordPerformanceMetric } from '../utils/awsRum';

/**
 * ページ表示時間計測 Hook
 *
 * コンポーネントのマウントから isLoaded が true になるまでの時間を
 * CloudWatch RUM に `page_load_{pageName}` として送信する。
 *
 * 1回のマウントにつき1回だけ記録する。
 */
export function usePageLoadMetric(pageName: string, isLoaded: boolean): void {
  const startTimeRef = useRef(performance.now());
  const hasRecordedRef = useRef(false);

  useEffect(() => {
    if (isLoaded && !hasRecordedRef.current) {
      hasRecordedRef.current = true;
      const duration = performance.now() - startTimeRef.current;
      recordPerformanceMetric(`page_load_${pageName}`, duration);
    }
  }, [isLoaded, pageName]);
}
